export const SideNavDataTop = [
  {
    title: "Home",
    path: "home",
    icon: "home",
    group: "top",
  },
  {
    title: "Discover",
    path: "discover",
    icon: "explore",
    group: "top",
  },
  {
    title: "Assist",
    path: "assist",
    icon: "chat_multiple",
    group: "top",
  },
  {
    title: "My Apps",
    path: "myapps",
    icon: "widgets",
    group: "top",
  },
  {
    title: "Saved",
    path: "saved",
    icon: "bookmark_border",
    group: "top",
  },
  {
    title: "Data Coverage",
    path: "dataCoverage",
    icon: "data_usage",
    group: "top",
  },
];

export const SideNavDataBottom = [
  {
    title: "Rapid",
    path: "rapid",
    icon: "content_view_gallery_lightning",
    group: "bottom",
  },
  {
    title: "Admin",
    path: "admin",
    icon: "people_settings",
    group: "bottom",
  },
  {
    title: "Docs",
    path: "resources",
    icon: "document_queue_multiple",
    group: "bottom",
  },
  {
    title: "FAQs",
    path: "faq",
    icon: "chat_bubbles_question",
    group: "bottom",
  },
  { title: "Help", path: "help", icon: "help_outline", group: "bottom" },
];
